<app-demo [datasource]="datasource" [context]="demoContext" [sources]="sources">
  <div actions>
    <div class="comment">Available since v1.3.1, undocumented</div>
    <button (click)="doUpdate()">Update</button> item #
    <input [(ngModel)]="inputValue" size="2" />
    <div>Items in buffer: {{ itemsInBuffer$ | async }}</div>
  </div>

  <div description>
    <p>
      The <em>Adapter.fix</em> method could be invoked with
      <em>updater</em> option which is a function that is applied to each
      element in the current Scroller's Buffer list and allows us to update
      buffered items on the fly. The argument of the <em>updater</em> function
      is an object of special <em>ItemAdapter</em> type
    </p>
    <pre>{{ itemAdapterDescription }}</pre>
    <p>
      The <em>data</em> is exactly what the <em>Datasource</em> sends to the
      Scroller as the items contents. So we have access to the items inside the
      Scroller's Buffer, and in this demo we update the <em>text</em> of
      selected item by its index. If we destroy the updated item by scrolling
      out and then scroll back, we will see that our update is gone. Speaking
      generally, we need to care about datasource consistency and every update
      we want to be applied to the Scroller's Buffer should also happen at the
      datasource level. The examples of Datasource-Adapter synching can be found
      <a
        [routerLink]="['/', adapterMethodsScope.id]"
        fragment="{{ adapterMethodsScope.map.appendPrependSync.id }}"
        >here</a
      >,
      <a
        [routerLink]="['/', adapterMethodsScope.id]"
        fragment="{{ adapterMethodsScope.map.remove.id }}"
        >here</a
      >
      and
      <a
        [routerLink]="['/', adapterMethodsScope.id]"
        fragment="{{ adapterMethodsScope.map.insert.id }}"
        >here</a
      >.
    </p>
    <p>
      The <em>Adapter.fix(&#123; updater &#125;)</em> usage can be very diverse.
      For example, we may not change anything in the buffer, but gather some
      statistic. In this demo <em>countItems</em> method uses
      <em>updater</em> to get a number of items in the buffer at a particular
      moment. The result is equal to the value of
      <em>Adapter.itemsCount</em> read-only property (<a
        [routerLink]="['/', adapterPropsScope.id]"
        fragment="{{ adapterPropsScope.map.itemsCount.id }}"
        >link</a
      >). Also, I would not recommend to bind <em>countItems</em>-like methods
      with the template as it is in this demo, for it might affect the
      performance.
    </p>
    <p>
      The <em>Adapter.fix-updater</em> method has the second argument
      <em>update</em> (available since v2.0.0-rc.6) which is a function that can
      be invoked in case the <em>Buffer.items</em> array reference needs to be
      updated.
    </p>
  </div>
</app-demo>
